import type { RouteRecordRaw } from "vue-router"

const logRoutes: Array<RouteRecordRaw> = [
  {
    path: "/lead-logs/global-postback",
    name: "globalPostback",
    component: () => import("@/views/settings/GlobalPostback.vue"),
    meta: {
      pageTitle: "Global Postback",
      breadcrumbs: ["Global Postback"],
    },
  },
  {
    path: "/lead-logs/platform-list-postback-log",
    name: "platform-list-postback-log",
    component: () => import("@/views/postback-logs/PostBackLog.vue"),
    meta: {
      pageTitle: "Postback Log",
      breadcrumbs: ["Lead Distribution", "Postback Log"],
    },
  },
  {
    path: "/lead-logs/platform-list-ping-log",
    name: "platform-list-ping-log",
    component: () => import("@/views/lead-distribution/PingLog.vue"),
    meta: {
      pageTitle: "Ping Log",
      breadcrumbs: ["Lead Distribution", "Ping Log"],
    },
  },
  {
    path: "/log",
    name: "log",
    children: [
      {
        path: "/activity-logs",
        name: "activity-logs",
        component: () => import("@/views/lead-distribution/activity-log/LogList.vue"),
        meta: {
          pageTitle: "Activity Logs",
          breadcrumbs: ["Activity Logs"],
        },
      },
      {
        path: "/retry-history",
        name: "retry-history",
        component: () => import("@/views/lead-distribution/retry-history/BulkRetryHistory.vue"),
        meta: {
          pageTitle: "Repost History",
          breadcrumbs: ["Repost History"],
        },
      },
    ],
  },
  {
    path: "/buyer-postback-log",
    name: "buyer-postback-log",
    component: () => import("@/views/lead-update-postback-log/LeadUpdatePostbackLog.vue"),
    meta: {
      pageTitle: "Buyer Postback Log",
      breadcrumbs: ["Buyer Postback Log"],
    },
  },
  {
    path: "/logs/realtime-postbacks",
    name: "realtime-postback-logs",
    component: () => import("@/views/realtime-postback-logs/RealtimePostbackLogs.vue"),
    meta: {
      pageTitle: "Real-Time Postback Logs",
      breadcrumbs: ["Real-Time Postback Logs"],
    },
  },
]

export default logRoutes
